import { useEffect } from 'react';
import Hotjar from '@hotjar/browser';

const useRegisterHotjarPage = (pageName: string) => {
  useEffect(() => {
    if (!Hotjar.isReady()) {
      return;
    }

    Hotjar.stateChange(pageName);
  }, [pageName]);
};

export default useRegisterHotjarPage;
